/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import videoBtn from "./img/videoBtn.png";
import { Button } from 'antd';
import {AUDIO_TYPE, ATTCHMENT_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../constants";

export default class DeliveryResources extends Component {
    static defaultProps = {
        img:'',
        type:'audio',
        checked:false,
        publish:false,
        showPublishBtn:false,
        text:'公开',
        imgOnclick:()=>{
            console.log('图片的信息')
        },
        onChangeChecked:(e)=>{
            console.log('checked')
        },
        singleOpen:()=>{
            console.log('公开按钮的点击事件')
        }
    };
    static propTypes = {
        img:PropTypes.string.isRequired,//传入图片,
        type:PropTypes.string.isRequired,//传入的type值
        checked:PropTypes.bool.isRequired,//选中的状态
        imgOnclick:PropTypes.func.isRequired,//回调函数
        onChangeChecked:PropTypes.func.isRequired,//checked回调函数
        publish:PropTypes.bool.isRequired,//是否是公开状态
        showPublishBtn:PropTypes.bool.isRequired,//是否显示公开/不公开按钮
        singleOpen:PropTypes.func.isRequired,//公开按钮的点击事件
        text:PropTypes.string.isRequired,//
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }
    render() {

        let ext = this.props.ext;
        let imgStyle = {width:'160px',height:'120px',objectFit:'contain'};
        if(AUDIO_TYPE.indexOf(ext) !== -1 || ATTCHMENT_TYPE.indexOf(ext) !== -1){
            imgStyle = {...imgStyle, width:"80px",height:'100px',left: "calc(50% - 40px)", top: "calc(50% - 50px)", position: "absolute" };
        }

        return (
            <div style={{cursor:'pointer'}}>
                <div style={{width:'160px',height:'133px',float:'left',margin:'0 20px 40px 20px',}}>
                    <div style={{width:'160px',height:'120px',background:"#a8a5a5",position:'relative'}}>
                        <img src={this.props.img} style={{...imgStyle}} onClick={()=>this.props.imgOnclick()} />
                        {this.props.type === 'video'?<img onClick={()=>this.props.imgOnclick()} style={{position:'absolute',width:'46px',height:'46px',left:'50%',top:'50%',marginLeft:'-23px',marginTop:'-23px'}} src={videoBtn}/>:null}
                        <Checkbox style={{position: 'absolute',left:'1px',bottom:5}} checked={this.props.checked} onChange={(e)=>{this.props.onChangeChecked(e)}}/>
                        {
                            this.props.showPublishBtn?<Button size="small" style={{position:'absolute',right:'0',bottom:'5px'}} onClick={()=>{this.props.singleOpen()}}>{
                                this.props.publish?"不公开":"公开"
                            }</Button>:""
                        }
                    </div>
                    <div className={"text-pointer"} style={{width:"160px",fontSize:"12px",textAlign:"center"}} title={this.props.name}>{this.props.name}</div>
                </div>
            </div>
        )
    }


}